import * as argentina from './argentina';
import * as australia from './australia';
import * as austria from './austria';
import * as belgium from './belgium';
import * as bolivia from './bolivia';
import * as bosniaHerzegovina from './bosniaHerzegovina';
import * as brazil from './brazil';
import * as canada from './canada';
import * as chile from './chile';
import * as china from './china';
import * as costaRica from './costaRica';
import * as croatia from './croatia';
import * as czechRepublic from './czechRepublic';
import * as denmark from './denmark';
import * as england from './england';
import * as finland from './finland';
import * as france from './france';
import * as general from './general';
import * as germany from './germany';
import * as greece from './greece';
import * as guatemala from './guatemala';
import * as hungary from './hungary';
import * as india from './india';
import * as ireland from './ireland';
import * as italy from './italy';
import * as japan from './japan';
import * as lebanon from './lebanon';
import * as lithuania from './lithuania';
import * as malta from './malta';
import * as mexico from './mexico';
import * as netherlands from './netherlands';
import * as newZealand from './newZealand';
import * as norway from './norway';
import * as panama from './panama';
import * as paraguay from './paraguay';
import * as peru from './peru';
import * as philippines from './philippines';
import * as poland from './poland';
import * as portugal from './portugal';
import * as puertoRico from './puertoRico';
import * as romania from './romania';
import * as russia from './russia';
import * as scotland from './scotland';
import * as slovakia from './slovakia';
import * as slovenia from './slovenia';
import * as spain from './spain';
import * as sriLanka from './sriLanka';
import * as sweden from './sweden';
import * as switzerland from './switzerland';
import * as test from './test';
import * as ukraine from './ukraine';
import * as unitedStates from './unitedStates';
import * as uruguay from './uruguay';
import * as venezuela from './venezuela';
import * as vietnam from './vietnam';
import * as wales from './wales';

export {
  argentina,
  australia,
  austria,
  belgium,
  bolivia,
  bosniaHerzegovina,
  brazil,
  canada,
  chile,
  china,
  costaRica,
  croatia,
  czechRepublic,
  denmark,
  england,
  finland,
  france,
  general,
  germany,
  greece,
  guatemala,
  hungary,
  india,
  ireland,
  italy,
  japan,
  lebanon,
  lithuania,
  malta,
  mexico,
  netherlands,
  newZealand,
  norway,
  panama,
  paraguay,
  peru,
  philippines,
  poland,
  portugal,
  puertoRico,
  romania,
  russia,
  scotland,
  slovakia,
  slovenia,
  spain,
  sriLanka,
  sweden,
  switzerland,
  test,
  ukraine,
  unitedStates,
  uruguay,
  venezuela,
  vietnam,
  wales,
};
